<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="cachePages" :exclude="[]">
      <component :is="Component" class="container" />
    </keep-alive>
  </router-view>
</template>

<script setup lang="ts">
import { useBaseStore } from '@/stores/base'
import router from '@/router'
import { FIRST_URL_KEY } from '@/utils/native'
import { getUserData, getHeaderData } from '@/utils/nativeAPI'
getUserData()
getHeaderData()
const { cachePages, setCachePages, removeCachePages } = useBaseStore()
const setBaseCachePage = () => {
  const openCacheRoute = router.options.routes
  openCacheRoute.map((c: any) => {
    if (c.meta?.keepAlive && c.name) {
      setCachePages(c.name)
    }
  })
}
// 初始化缓存页面
setBaseCachePage()

// 动态缓存
router.beforeEach((to: any, from: any, next) => {
  if (to.query?._t === undefined) {
    //用时间戳来判断前进后退
    to.query._t = new Date().getTime()
    next({
      path: to.path,
      query: to.query
    })
  } else {
    if (to.query?._t && from.query?._t) {
      if (to.query._t - from.query._t > 0) {
        //前进
        if ('isDynamic' in to.meta && to.name) {
          to.meta.isDynamic = !to.meta.isDynamic
          setCachePages(to.name)
        }
      } else {
        //后退
        if ('isDynamic' in from.meta && from.name) {
          from.meta.isDynamic = !from.meta.isDynamic
          removeCachePages(from.name)
        }
      }
    }
    next()
  }
})
window.localStorage.setItem(FIRST_URL_KEY, window.location?.href)
</script>

<style lang="less">
@import url('@/styles/reset.less');
</style>
